import { skipNavStyles } from "@insite/content-library/Components/SkipNav";
import { css } from "styled-components";

skipNavStyles.skipToContent = {
    ...skipNavStyles.skipToContent,
    css: css`
        ${skipNavStyles.skipToContent?.css}

        &&&& {
            position: absolute;
        }
    `,
};
